const persistentReducerCreator = (actionType, struct) => {
  const data = JSON.parse(localStorage.getItem(actionType)) || struct
  return (state = data, action = { type: '', payload: struct }) => {
    switch (action.type) {
      case `${actionType}_SUCCESS`:
        localStorage.setItem(actionType, JSON.stringify(action.payload))
        return action.payload
      case `${actionType}_FAIL`:
        return state
      default:
        return state
    }
  }
}

export default persistentReducerCreator
